export default function(value: string) {
    return parseFloat(value).toFixed(2);
}
